// Hook pro publikaci dynamického NÁZVU native okna z načtených dat detailu.
//
// `layerId` čte z `useCurrentLayerId()` (LayerReloadScope) — stejně jako `useRegisterLayerReload`,
// takže funguje i ve vnořené komponentě, která vlastní data (např. `SerieDetailView`), bez prop-drillingu.
//
// Titulek se zapíše do `nativeWindowTitleStore` (→ hlavička okna, taskbar, breadcrumb přes
// `deriveDesktopProjection`) a doplní do navázaného záznamu historie (`updateAgendaHistoryTitleForLayer`).
// Prázdný/undefined titulek = no-op (ponechá statický fallback z agendy). Na unmount se vrstva ze storu
// uklidí; `PhoenixDesktop.prune` je navíc bezpečnostní síť pro zavřené vrstvy.
//
// POZOR: volat jednou za okno (v komponentě vlastnící data). Dvojí volání v jednom okně = last-write-wins.

import { useEffect } from 'react';

import { updateAgendaHistoryTitleForLayer } from '@/shared/lib/agendaHistory';
import { useCurrentLayerId } from '@/shared/lib/layerReload';

import { useNativeWindowTitleStore } from '../core/nativeWindowTitleStore';

export function useWindowTitle(title: string | null | undefined): void {
  const layerId = useCurrentLayerId();
  const set = useNativeWindowTitleStore((s) => s.set);
  const clear = useNativeWindowTitleStore((s) => s.clear);

  // Set na změnu titulku (bez clearu → změna titulku neprobliká přes prázdný stav).
  useEffect(() => {
    if (!layerId || !title) return;
    set(layerId, title);
    updateAgendaHistoryTitleForLayer(layerId, title);
  }, [layerId, title, set]);

  // Clear až na unmount / změnu vrstvy.
  useEffect(() => {
    if (!layerId) return;
    return () => clear(layerId);
  }, [layerId, clear]);
}
